import cookies from 'js-cookie';

const { REACT_APP_AUTH_COOKIE_DOMAIN } = process.env;

const AUTH_COOKIE_NAME = 'x-auth-token';
const CSRF_COOKIE_NAME = 'x-csrf-token';
const EMPLOYEE_ID_COOKIE_NAME = 'employee-id';

export const isAuthCookiePresent = () =>
  cookies.get(AUTH_COOKIE_NAME) && cookies.get(AUTH_COOKIE_NAME) !== null;

export const saveAuthCookie = (cookieValue: $TSFixMe) => {
  if (REACT_APP_AUTH_COOKIE_DOMAIN) {
    cookies.set(AUTH_COOKIE_NAME, cookieValue, {
      domain: REACT_APP_AUTH_COOKIE_DOMAIN,
    });
  } else {
    cookies.set(AUTH_COOKIE_NAME, cookieValue);
  }
};

export const removeAuthCookie = () => {
  if (REACT_APP_AUTH_COOKIE_DOMAIN) {
    cookies.remove(AUTH_COOKIE_NAME, {
      domain: REACT_APP_AUTH_COOKIE_DOMAIN,
    });
  } else {
    cookies.remove(AUTH_COOKIE_NAME);
  }
};

export const getAuthCookie = () => cookies.get(AUTH_COOKIE_NAME);

export const getAuthTokenKey = () => AUTH_COOKIE_NAME;

export const getCSRFToken = () => cookies.get(CSRF_COOKIE_NAME);

export const saveEmployeeIdCookie = (employee_id: $TSFixMe) => {
  if (REACT_APP_AUTH_COOKIE_DOMAIN) {
    cookies.set(EMPLOYEE_ID_COOKIE_NAME, employee_id, {
      domain: REACT_APP_AUTH_COOKIE_DOMAIN,
    });
  } else {
    cookies.set(EMPLOYEE_ID_COOKIE_NAME, employee_id);
  }
};

export const getEmployeeIdCookie = () => cookies.get(EMPLOYEE_ID_COOKIE_NAME);

export const removeEmployeeIdCookie = () => {
  if (REACT_APP_AUTH_COOKIE_DOMAIN) {
    cookies.remove(EMPLOYEE_ID_COOKIE_NAME, {
      domain: REACT_APP_AUTH_COOKIE_DOMAIN,
    });
  } else {
    cookies.remove(EMPLOYEE_ID_COOKIE_NAME);
  }
};
